import axios from "axios";

const authDev = {
    auth: {
      username: 'turnera_front_dev',
      password: '4J9R@g&5xS2N'
    }
  }

const authProd = {
    auth: {
        username: 'turnera_front_prd',
        password: '3i5O$B2$6j@h'
    }
  }

//  LOCAL DEV -> 0  ||  PAGINA DEV -> 1  ||  PROD -> 2

  const sitiado = 2;
  const sitios = ["http://localhost:3000/turnera/apiTurnera/index.php", "http://10.100.17.102/turnera/apiTurnera/index.php", "https://api-turnera.vicentelopez.gov.ar", "http://prd-mod-web13.vicentelopez.gov.ar/turnera/apiTurnera/index.php"]

  const sitiosDeportes = ["https://api-deportes.vicentelopez.gov.ar", "https://api-deportes.vicentelopez.gov.ar", "https://api-deportes.vicentelopez.gov.ar", "https://api-deportes.vicentelopez.gov.ar"]
//   const sitiosDeportes = ["http://10.100.18.213:3000", "http://10.100.18.213:3000", "https://api-deportes.vicentelopez.gov.ar", "https://api-deportes.vicentelopez.gov.ar"]
  const authDinamico = (sitiado<=1 ? authDev : authProd);

// DINAMICO
const todosModulos = async (state, setCarga) => {
    setCarga(true);
    const peticion = await axios
    .get(`${sitios[sitiado]}/api/modulos`, authDinamico);
    state(peticion.data);
    
    setCarga(false);
    return peticion.data;
}

const delegacionesPorModulo = async (state, modulo, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`${sitios[sitiado]}/api/dependencias/${modulo}`, authDinamico);
    state(peticion.data);
    setCarga(false);
    return peticion.data;
}

const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`${sitios[sitiado]}/api/servicios/${delegacion}`, authDinamico);
    state(peticion.data);
    setCarga(false);

    return peticion.data;
}

const stringADate = (string) =>{
    const dateAux = new Date(string.diaCompleto + "T00:00:00");
    return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate(), turnoActivo: string.turnoActivo, cantidad: string.cantidad}
}

const diasPorServicio = async (servicio, mes, anio, setCarga, DNIs, setTieneUnTurnoActivo1 = null) => {
    setCarga(true);
    let fechasAux =[];
    const peticion = await axios.post(`${sitios[sitiado]}/api/servicios/${servicio}/all/null`, DNIs || {}, authDinamico);
    // const peticion = await axios.post(`${sitios[sitiado]}/api/servicios/${servicio}/${mes}/${anio}`, DNIs || {}, authDinamico);
    if (!peticion.data.status) {
        for (let i = 0; i < peticion.data.length; i++) {
            const element = peticion.data[i];
            if (element.turnoActivo) {
                setTieneUnTurnoActivo1(true)
                console.log(element)
            }
        }
        peticion.data.
            filter(fecha => fecha.cantidad >= 1).
            map(pet => fechasAux.push(stringADate(pet)));
    }
    else {
        setCarga(false);
        return peticion.data;
    }

    setCarga(false);
    return (fechasAux);
}

const addDays = (startDate) => {
    const date = new Date(startDate.year, (startDate.month - 1), 0);
    let datesCollection = []
    
    for (var i = 1; i < 365; i++) {
        const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
        datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
    }
    
    return datesCollection;
}

const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
    setCarga(true);
    const peticion = await axios.get(`${sitios[sitiado]}/api/servicios/${servicio}/${dia}/${mes}/${anio}`, authDinamico);

    await state(peticion.data);
    setCarga(false);
    return peticion.data;
}

const DNIestaRegistrado = async (DNI, setCarga) => {
    if (DNI == null || DNI == "") {
        return {registered: false};
    }
    setCarga(true);
    const peticion = await axios.get(`${sitiosDeportes[sitiado]}/users/single/isBookingEnabled/${DNI}`, authDinamico);
    setCarga(false);
    return peticion.data;
}

const DNIestaRegistradoMultiple = async (DNI, setCarga) => {
    if (DNI == null || DNI == "") {
        return {registered: false};
    }
    setCarga(true);
    const peticion = await axios.post(`${sitiosDeportes[sitiado]}/users/various`, DNI, authDinamico);
    setCarga(false);
    console.log(peticion)
    return peticion.data;
}


// LOCAL
// const todosModulos = async (state, setCarga) => {
//     setCarga(true);
//     const peticion = await axios
//     .get('http://localhost:3000//turnera/apiTurnera/index.php/api/modulos', authDev);
//     state(peticion.data);
    
//     setCarga(false);
//     return peticion.data;
// }

// const delegacionesPorModulo = async (state, modulo, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/dependencias/${modulo}`, authDev);
//     state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/servicios/${delegacion}`, authDev);
//     state(peticion.data);
//     setCarga(false);

//     return peticion.data;
// }

// const stringADate = (string) =>{
//     const dateAux = new Date(string + "T00:00:00");
//     return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
// }

// const diasPorServicio = async (servicio, mes, anio, setCarga, DNIs) => {
//     setCarga(true);
//     let fechasAux =[];
//     const peticion = await axios.post(`http://localhost:3000//turnera/apiTurnera/index.php/api/servicios/${servicio}/${mes}/${anio}`, DNIs || {}, authDev);
//     console.log(peticion)
//     if (!peticion.data.status) {
//         peticion.data.
//             filter(fecha => fecha.cantidad > 0).
//             map(pet => fechasAux.push(stringADate(pet.diaCompleto)));
//     }
//     else {
//         setCarga(false);
//         return "error";
//     }

//     setCarga(false);
//     return (fechasAux);
// }

// const addDays = (startDate) => {
//     const date = new Date(startDate.year, (startDate.month - 1), 0);
//     let datesCollection = []
    
//     for (var i = 1; i < 365; i++) {
//         const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
//         datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
//     }
    
//     return datesCollection;
// }

// const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://localhost:3000//turnera/apiTurnera/index.php/api/servicios/${servicio}/${dia}/${mes}/${anio}`, authDev);

//     await state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistrado = async (DNI, setCarga) => {
//     if (DNI == null || DNI == "") {
//         return {registered: false};
//     }
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213:3000/users/single/isBookingEnabled/${DNI}`, authDev);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistradoMultiple = async (DNI, setCarga) => {
//     if (DNI == null || DNI == "") {
//         return {registered: false};
//     }
//     setCarga(true);
//     console.log(DNI)
//     const peticion = await axios.post(`http://10.100.18.213:3000/users/various`, DNI, authDev);
//     setCarga(false);
//     return peticion.data;
// }





// DEV SERVER
// const todosModulos = async (state, setCarga) => {
//     setCarga(true);
//     const peticion = await axios
//     .get('http://10.100.18.213/turnera/apiTurnera/index.php/api/modulos', authDev);
//     state(peticion.data);
    
//     setCarga(false);
//     return peticion.data;
// }

// const delegacionesPorModulo = async (state, modulo, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/dependencias/${modulo}`, authDev);
//     state(peticion.data);
//     console.log(peticion.data)
//     setCarga(false);
//     return peticion.data;
// }

// const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/servicios/${delegacion}`, authDev);
//     state(peticion.data);
//     setCarga(false);

//     return peticion.data;
// }

// const stringADate = (string) =>{
//     const dateAux = new Date(string + "T00:00:00");
//     return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
// }

// const diasPorServicio = async (servicio, mes, anio, setCarga, DNIs) => {
//     setCarga(true);
//     let fechasAux =[];
//     const peticion = await axios.post(`http://10.100.18.213/turnera/apiTurnera/index.php/api/servicios/${servicio}/all/null`,DNIs || {}, authDev);
//     if (!peticion.data.status) {
//         peticion.data.
//             filter(fecha => fecha.cantidad > 0).
//             map(pet => fechasAux.push(stringADate(pet.diaCompleto)));
//     }
//     else {
//         setCarga(false);
//         return "error";
//     }

//     setCarga(false);
//     return (fechasAux);
// }

// const addDays = (startDate) => {
//     const date = new Date(startDate.year, (startDate.month - 1), 0);
//     let datesCollection = []
    
//     for (var i = 1; i < 365; i++) {
//         const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
//         datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
//     }
    
//     return datesCollection;
// }

// const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
//     // setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213/turnera/apiTurnera/index.php/api/servicios/${servicio}/${dia}/${mes}/${anio}`, authDev);

//     await state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistrado = async (DNI, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`http://10.100.18.213:3000/users/single/isBookingEnabled/${DNI}`, authDev);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistradoMultiple = async (DNI, setCarga) => {
//     if (DNI == null || DNI == "") {
//         return {registered: false};
//     }
//     setCarga(true);
//     console.log(DNI)
//     const peticion = await axios.post(`http://10.100.18.213:3000/users/various`, DNI, authDev);
//     setCarga(false);
//     return peticion.data;
// }



// PROD
// const todosModulos = async (state, setCarga) => {
//     setCarga(true);
//     const peticion = await axios
//     .get('https://api-turnera.vicentelopez.gov.ar/api/modulos');
//     state(peticion.data);
    
//     setCarga(false);
//     return peticion.data;
// }

// const delegacionesPorModulo = async (state, modulo, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/dependencias/${modulo}`);
//     state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const serviciosPorDelegacion = async (state, delegacion, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${delegacion}`);
//     state(peticion.data);
//     setCarga(false);

//     return peticion.data;
// }

// const stringADate = (string) =>{
//     const dateAux = new Date(string + "T00:00:00");
//     return {year: dateAux.getFullYear(), month: dateAux.getMonth() + 1 , day: dateAux.getDate()}
// }

// const diasPorServicio = async (servicio, mes, anio, setCarga) => {
//     setCarga(true);
//     let fechasAux =[];
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${servicio}/${mes}/${anio}`);
//     if (!peticion.data.status) {
//         peticion.data.
//             filter(fecha => fecha.cantidad > 0).
//             map(pet => fechasAux.push(stringADate(pet.diaCompleto)));
//     }
//     else {
//         setCarga(false);
//         return "error";
//     }

//     setCarga(false);
//     return (fechasAux);
// }

// const addDays = (startDate) => {
//     const date = new Date(startDate.year, (startDate.month - 1), 0);
//     let datesCollection = []
    
//     for (var i = 1; i < 365; i++) {
//         const newDate = new Date(date.getTime() + i * 1000 * 60 * 60 * 24);
//         datesCollection.push({year: newDate.getFullYear(), month: newDate.getMonth() + 1 , day: newDate.getDate()});
//     }
    
//     return datesCollection;
// }

// const horasPorDia = async (state, servicio, dia, mes, anio, setCarga) => {
//     // setCarga(true);
//     const peticion = await axios.get(`https://api-turnera.vicentelopez.gov.ar/api/servicios/${servicio}/${dia}/${mes}/${anio}`);

//     await state(peticion.data);
//     setCarga(false);
//     return peticion.data;
// }

// const DNIestaRegistrado = async (DNI, setCarga) => {
//     setCarga(true);
//     const peticion = await axios.get(`https://api-deportes.vicentelopez.gov.ar/users/single/isBookingEnabled/${DNI}`);
//     setCarga(false);
//     return peticion.data;
// }





export {
    todosModulos,
    delegacionesPorModulo,
    serviciosPorDelegacion,
    diasPorServicio,
    horasPorDia,
    addDays,
    DNIestaRegistrado,
    DNIestaRegistradoMultiple,
}